module.exports = __webpack_public_path__ + "static/media/img-folder-icon.efcbdb4c.svg";